import React, { createContext, useContext, useMemo, useState } from 'react';

type ContextType = {
  shouldShowStickyBanner: boolean;
  shouldShowStickyFooter: boolean;
  setShouldShowStickyBanner: (value: boolean) => void;
  setShouldShowStickyFooter: (value: boolean) => void;
};

const defaultContext: ContextType = {
  shouldShowStickyBanner: false,
  shouldShowStickyFooter: false,
  setShouldShowStickyBanner: () => {},
  setShouldShowStickyFooter: () => {}
};

const StickyBannerContext = createContext<ContextType>(defaultContext);

export const StickyBannerContextProvider = ({
  children
}: React.PropsWithChildren) => {
  const [shouldShowStickyBanner, setShouldShowStickyBanner] = useState(false);
  const [shouldShowStickyFooter, setShouldShowStickyFooter] = useState(false);

  const value = useMemo(
    () => ({
      shouldShowStickyBanner,
      shouldShowStickyFooter,
      setShouldShowStickyBanner,
      setShouldShowStickyFooter
    }),
    [shouldShowStickyBanner, shouldShowStickyFooter]
  );

  return (
    <StickyBannerContext.Provider value={value}>
      {children}
    </StickyBannerContext.Provider>
  );
};

StickyBannerContextProvider.displayName = 'StickyBannerContextProvider';

export const useStickyBanner = () => {
  return useContext(StickyBannerContext);
};

export default StickyBannerContext;
